import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const stores = [
  {
    id: 1,
    name: "Amazon",
    logo: "https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg",
    offer: "Upto 4% Rewards",
    tag: "amazon",
  },
 
];

const CategoryStores = () => {
  const openStore = (tag) => {
    const clickId = Math.random().toString(36).substring(2, 10);

    const finalLink = `https://www.amazon.in/?tag=digitalspires-21&ascsubtag=${tag}-${clickId}`;

    window.open(finalLink, "_blank");
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* ⭐ Header Added */}
      <Header />

      <div className="px-6 py-8 max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-8">Electronics</h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {stores.map((store) => (
            <div
              key={store.id}
              onClick={() => openStore(store.tag)}
              className="cursor-pointer border rounded-xl shadow-md hover:shadow-lg transition p-6 text-center bg-white"
            >
              <div className="h-32 flex items-center justify-center">
                <img
                  src={store.logo}
                  alt={store.name}
                  className="max-h-20 object-contain"
                />
              </div>

              <div className="mt-4 bg-blue-600 text-white py-2 rounded-lg font-semibold">
                {store.offer}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ⭐ Footer Added */}
      <Footer />
    </div>
  );
};

export default CategoryStores;
